module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAARCAMAAAAFWBeyAAAAbFBMVEUAAADEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzVair7hAAAAI3RSTlMA8irbig8GtFLu4da4mYN5bFhOHRML+ejIv55/ZkRDNiYkGVLapTkAAAB9SURBVBjTbY9ZDoQgFAQBEfdRR519te5/RyVGg2B/9au8pNIizFmPBxCSACoJDx/2EUSxB80dpPJfKyD1YQOcbBn006zww+qvoRwW+M82UwvcetviwjHVQNHN+nJnegH5T+jFtCW9wNXCxAgnbwmEm74ZR5tUDq0I0lWNc00TNwq2QcwelQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/view/shopping/images/ic_index_gou.png
// module id = IsZU
// module chunks = 21